// extracted by mini-css-extract-plugin
export default {"search-bar":"Search_search-bar__yReiQ"};